import { useQuery } from "@tanstack/react-query";
import { getUserProfile } from "../api/preInvoiceApi";
import { preInvoiceKeys } from "../api/preInvoiceKeys";

// Perfil del usuario logueado (nombre para el archivo, email para el período).
export const usePreInvoiceUser = () =>
  useQuery({
    queryKey: preInvoiceKeys.userProfile(),
    queryFn: getUserProfile,
  });
